import React from 'react';

export const TabsHeader = ({ title, subtitle, text, children }) => {
	return (
		<div className='content-column col-md-6 col-sm-12 col-xs-12'>
			<div className='inner'>
				<div className='sec-title'>
					<h4 className='subtitle'>{subtitle}</h4>
					<h2 dangerouslySetInnerHTML={{ __html: `${title}` }} />
				</div>

				<div className='text'>{text}</div>
				 <ul class="tab-btns clearfix web">
					{children[0]}
				 </ul>
				<ul className="tab-btns clearfix web">
					{children[1]}
				</ul>
				<ul className="tab-btns clearfix web">
					{children[2]}
				</ul>
				<ul className="tab-btns clearfix web">
					{children[3]}
				</ul>
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// ./src/components/ui/Tabs/TabsHeader.js